import { stringifyQuery } from '~/components/tool/Query';
import { ToDoListResponse, TodoListRequest } from '~/types/Todo';

export interface TodoApi {
  getTodoList: (param: TodoListRequest) => Promise<ToDoListResponse>;
}

export const useTodoApi = (fetch): TodoApi => {
  /** やることリスト一覧取得 */
  const getTodoList = async (param: TodoListRequest): Promise<ToDoListResponse> => {
    const response = await fetch(`/portal/me/todoLists/${stringifyQuery(param)}`);
    return response.data;
  };

  return {
    getTodoList,
  };
};
